<template>
    <b-modal :id="modalId" :title="isEditing ? 'Meta Verisi Düzenle' : 'Yeni Meta Verisi Ekle'" ok-title="Kaydet" cancel-title="İptal" @ok="handleOk" @hidden="resetModal" centered>
        <b-form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group label="Dil" label-for="meta-language">
                <v-select-list id="meta-language" v-model="localItem.LanguageCode" :options="languages" label="LanguageName" :reduce="(lang) => lang.LanguageCode" placeholder="Tüm Diller (Genel)" />
            </b-form-group>

            <b-form-group label="Grup Giriş Yöntemi" label-for="meta-group-type" class="mb-1">
                <b-form-radio-group
                    id="meta-group-type"
                    v-model="groupInputMode"
                    :options="[
                        { text: 'Yeni Grup Oluştur', value: 'new' },
                        { text: 'Mevcut Gruptan Seç', value: 'select', disabled: groupOptions.length === 0 },
                    ]"
                    buttons
                    button-variant="basic"
                    class="custom-group-toggle w-100"
                />
            </b-form-group>

            <b-form-group v-if="groupInputMode === 'select'" label="Grup Seçimi" label-for="meta-group-select">
                <v-select-list id="meta-group-select" v-model="localItem.MetaGroup" :options="groupOptions" label="label" :reduce="(opt) => opt.value" placeholder="Listeden bir grup seçin" />
            </b-form-group>

            <b-form-group v-else label="Yeni Grup Adı" label-for="meta-group-input">
                <b-form-input id="meta-group-input" v-model="localItem.MetaGroup" placeholder="Yeni grup adı girin" trim />
            </b-form-group>

            <b-row>
                <b-col cols="12">
                    <b-form-group label="Anahtar (Key)" label-for="meta-key" class="is-required">
                        <b-form-input id="meta-key" v-model="localItem.MetaKey" placeholder="Anahtar" required />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-form-group label="Değer (Value)" label-for="meta-value" class="is-required">
                <b-form-textarea id="meta-value" v-model="localItem.MetaValue" placeholder="Değer" rows="3" required />
            </b-form-group>

            <b-form-group label="Sıra" label-for="meta-sort">
                <b-form-spinbutton id="meta-sort" v-model="localItem.SortOrder" min="0" />
            </b-form-group>
        </b-form>
    </b-modal>
</template>

<script>
import { BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BRow, BCol, BFormSpinbutton, BFormRadioGroup } from "bootstrap-vue";

export default {
    name: "MetaDataModal",
    components: {
        BModal,
        BForm,
        BFormGroup,
        BFormInput,
        BFormTextarea,
        BRow,
        BCol,
        BFormSpinbutton,
        BFormRadioGroup,
    },
    props: {
        modalId: {
            type: String,
            default: "modal-meta-data",
        },
        item: {
            type: Object,
            default: () => ({}),
        },
        languages: {
            type: Array,
            default: () => [],
        },
        groupOptions: {
            type: Array,
            default: () => [],
        },
        isEditing: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            localItem: { ...this.item },
            groupInputMode: "new",
        };
    },
    watch: {
        item: {
            handler(newVal) {
                this.localItem = { ...newVal };
                const groupExists = newVal.MetaGroup && this.groupOptions.some((g) => g.value === newVal.MetaGroup);

                if (this.groupOptions.length > 0 && groupExists) {
                    this.groupInputMode = "select";
                } else {
                    this.groupInputMode = "new";
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault();
            this.handleSubmit();
        },
        handleSubmit() {
            if (!this.localItem.MetaKey || !this.localItem.MetaValue) {
                this.$bvToast.toast("Anahtar ve Değer alanları zorunludur.", {
                    title: "Hata",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            this.$emit("save", this.localItem);
            this.$nextTick(() => {
                this.$bvModal.hide(this.modalId);
            });
        },
        resetModal() {
            this.localItem = { ...this.item };
            this.$emit("hidden");
        },
    },
};
</script>

<style scoped>
.is-required >>> label::after,
.is-required /deep/ label::after {
    content: " *";
    color: #dc3545;
    font-weight: 700;
}

.custom-group-toggle {
    background-color: #ebe9f1;
    padding: 4px;
    border-radius: 6px;
    border: none;
    display: flex;
}

.custom-group-toggle ::v-deep .btn {
    border: none !important;
    box-shadow: none !important;
    background-color: transparent !important;
    color: #b9b9c3 !important;
    border-radius: 4px;
    font-size: 0.9rem;
    font-weight: 500;
    flex: 1;
    transition: all 0.2s ease;
    padding: 8px 12px;
    outline: none !important;
}

.custom-group-toggle ::v-deep .btn.active {
    background-color: #ffffff !important;
    color: #5e5873 !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    font-weight: 600;
}

.custom-group-toggle ::v-deep .btn:not(.active):hover {
    color: #6e6b7b !important;
}

.custom-group-toggle ::v-deep .btn.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    color: #d0d2d6 !important;
}

.dark-layout .custom-group-toggle {
    background-color: #161d31 !important;
    border: 1px solid #3b4253;
}

.dark-layout .custom-group-toggle ::v-deep .btn {
    color: #676d7d !important;
}

.dark-layout .custom-group-toggle ::v-deep .btn:not(.active):hover {
    color: #d0d2d6 !important;
}

.dark-layout .custom-group-toggle ::v-deep .btn.active {
    background-color: #283046 !important;
    color: #d0d2d6 !important;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.4) !important;
}

.dark-layout .custom-group-toggle ::v-deep .btn.disabled {
    color: #404656 !important;
}
</style>
